<template>
    <div id="login">
        <h1>Login</h1>
        <input type="text"
               v-bind:class="{ 'error': hasError }"
               name="username" v-model="input.username"
               v-on:keyup.enter="login()"
               placeholder="Username"/>
        <input type="password"
               v-bind:class="{ 'error': hasError }"
               v-on:keyup.enter="login()"
               name="password" v-model="input.password"
               placeholder="Password"/>
        <button type="button" v-on:click="login()">Login</button>
    </div>
</template>

<script>
  import Api from '../Api'

  export default {
    name: 'Login',
    data () {
      return {
        input: {
          username: '',
          password: ''
        },
        hasError: false
      }
    },
    methods: {
      login () {
        this.hasError = false;
        Api.login(this.input.username, this.input.password)
          .then((response) => {
            let redirectPath = localStorage.getItem('redirectAfterLogin')
            if (redirectPath !== null && typeof redirectPath !== 'undefined') {
              localStorage.removeItem('redirectAfterLogin')
              this.$router.push(redirectPath)
            } else {
              this.$router.push('/')
            }
          })
          .catch((msg) => {
            if (msg === 'FAILD') {
              this.hasError = true;
            }
          })
      }
    }
  }
</script>

<style scoped>
    #login {
        width: 500px;
        border: 1px solid #CCCCCC;
        background-color: #FFFFFF;
        margin: auto;
        margin-top: 200px;
        padding: 20px;


    }
    input.error {
        border: 1px solid red;
        color: red;
    }
</style>


// WEBPACK FOOTER //
// src/components/Login.vue